import { render } from "./WorkspaceCreateFastEditModal.vue?vue&type=template&id=68ff2a0c&scoped=true"
import script from "./WorkspaceCreateFastEditModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceCreateFastEditModal.vue?vue&type=script&lang=js"

import "./WorkspaceCreateFastEditModal.vue?vue&type=style&index=0&id=68ff2a0c&lang=scss&scoped=true"
import "./WorkspaceCreateFastEditModal.vue?vue&type=style&index=1&id=68ff2a0c&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ff2a0c"]])

export default __exports__